export const PaymentMethods = [
  "cash",
  "card",
  "stripe",
  "paypal",
  "cardconnect",
  "paygate_payweb",
  "poli_pay",
  "ipay88",
  "bambora_apac",
  "pesapal",
];
